
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	filtro: {},
	lista: [],
	listaSelect: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'SETOR_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'SETOR_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'SETOR_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'SETOR_LISTADO':
            return {
				...state,
				lista: action.payload.data,
				listaSelect: action.payload.data.filter(item => item.ativo).map(item => ({
					id: item.id,
					valor: item.nome,

					id_setor_pai: item.id_setor_pai,
					
					ids_usuarios: item.ids_usuarios,
					ids_usuarios_supervisores: item.ids_usuarios_supervisores,
					ids_usuarios_gestores: item.ids_usuarios_gestores,

					ids_usuarios_completo: item.ids_usuarios_completo,
					ids_usuarios_supervisores_completo: item.ids_usuarios_supervisores_completo,
					ids_usuarios_gestores_completo: item.ids_usuarios_gestores_completo
				}))
			};
			
		case 'SETOR_USUARIO_SELECT_LISTADO':
            return { ...state,
				listaUsuario: action.payload.data.filter(item => !item.acesso_cliente)
			};

        default:
            return state;
    }
}
